import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function leadStatusInfoReducer(state = initialState.leadStatusInfo, action) {
  switch (action.type) {
    case types.LOAD_LEAD_STATUS_INFO_SUCCESS:
      return action.leadStatusInfo;
    default:
      return state;
  }
}
